import { render, staticRenderFns } from "./schoolDepartment.vue?vue&type=template&id=3afe5ff0&scoped=true"
import script from "./schoolDepartment.vue?vue&type=script&lang=js"
export * from "./schoolDepartment.vue?vue&type=script&lang=js"
import style0 from "./schoolDepartment.vue?vue&type=style&index=0&id=3afe5ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe5ff0",
  null
  
)

export default component.exports